const { DEV, MODE } = import.meta.env;

export const isProduction = MODE === 'production';
export const isStaging = MODE === 'staging' && !DEV;
export const isDEV = () => DEV || location.href.indexOf('gtm') > -1;
